import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { pick, omit } from '@styled-system/props'
import Box from '../Box'
import Flex from '../Flex'
import TextInput, { TextInputBox } from '../TextInput'

const IconBox = (props) => (
  <Box
    {...props}
    css={{
      width: 'auto',
      flex: '0 0 auto',
      p: 0,
      px: 1,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    }}
  />
)

const IconTextInput = forwardRef((props, ref) => {
  const {
    css,
    leftIcon,
    rightIcon,
    variant,
    placeholder,
    ...restProps
  } = props

  const styledProps = pick(restProps)
  const inputProps = omit(restProps)

  return (
    <TextInputBox variant={variant} m={0} css={css} {...styledProps}>
      <Flex>
        {leftIcon && <IconBox>{leftIcon}</IconBox>}
        <TextInput
          {...inputProps}
          variant="transparent"
          ref={ref}
          placeholder={placeholder}
          css={{
            flex: 1,
            border: 0,
            px: 1,
            py: 0,
            m: 0,
          }}
        />
        {rightIcon && <IconBox>{rightIcon}</IconBox>}
      </Flex>
    </TextInputBox>
  )
})

IconTextInput.displayName = 'IconTextInput'

IconTextInput.propTypes = {
  css: PropTypes.object,
  variant: PropTypes.string,
  placeholder: PropTypes.string,
  leftIcon: PropTypes.node,
  rightIcon: PropTypes.node,
}

IconTextInput.defaultProps = {
  variant: 'primary',
}

export default IconTextInput
